import { Element } from "@siteimprove/alfa-dom";
import { PseudoClassSelector } from "./pseudo-class.js";
const { hasName, isElement } = Element;
/**
 * {@link https://drafts.csswg.org/selectors/#last-of-type-pseudo}
 */
export class LastOfType extends PseudoClassSelector {
    static of() {
        return new LastOfType();
    }
    constructor() {
        super("last-of-type");
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element) {
        return element
            .inclusiveSiblings()
            .filter(isElement)
            .filter(hasName(element.name))
            .last()
            .includes(element);
    }
    toJSON() {
        return super.toJSON();
    }
}
(function (LastOfType) {
    LastOfType.parse = PseudoClassSelector.parseNonFunctional("last-of-type", LastOfType.of);
})(LastOfType || (LastOfType = {}));
//# sourceMappingURL=last-of-type.js.map